import React from "react";
import getStatus from "./getStatus";
import BatteryPackColumn from "./BatteryPackColumn";
import { ITEM_STATUS } from "../Login/constants";
import RetiredBadge from "../../Core/Components/RetiredBadge";

const AssetStatusColumn = ({ record }) => {
  return (
    <div className="flex items-center gap-x-3">
      {+record.isActive === ITEM_STATUS.RETIRED ? (
        <RetiredBadge />
      ) : (
        getStatus(+record.status)
      )}

      {record?.agentFirstName ? (
        <div className="flex items-center gap-x-3">
          <div className="w-[1px] h-[26px] border border-light-grey rounded-md" />

          <div className="font-aileron text-dark-gray capitalize whitespace-nowrap">
            <p className="text-xs font-semibold">
              {record?.agentFirstName} {record?.agentLastName}
            </p>
            <p className="text-10 font-normal">Agent</p>
          </div>
        </div>
      ) : null}

      {record?.batteryPack?.length ? (
        <div className="flex items-center gap-x-3">
          <div className="w-[1px] h-[26px] border border-light-grey rounded-md" />

          <div>
            <BatteryPackColumn record={record} />
            <p className="text-10 font-aileron text-dark-gray font-normal">
              Battery
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AssetStatusColumn;
